import React from "react";
import MyTitle from "../../myTitle";
import styleObj from "../style.module.scss";
import title from "../../../assets/imgs/Invitation2021.png";

export default function Invitation(props) {
  let { list, routeName } = props;
  return (
    !!list.length && (
      <div className={styleObj["Invitation-wrap"]}>
        <MyTitle {...props} title={title} />
        <ul className={styleObj["Invitation-list"]}>
          {list.map((item, i) => (
            <li key={i}>
              <div className={styleObj["avatar"]}>
                {/* <img src={require(`../../assets/imgs/${item.pic}`)} alt="" /> */}
                <img src={`//s2.jiguo.com/${item.pic}`} alt="" />
              </div>
              <div className={styleObj["intro"]}>
                <div
                  style={{ color: "#FFECD0" }}
                  className={styleObj["nickname"]}
                >
                  {item.name}
                </div>
                <div className={styleObj["desc"]}>
                  <p style={{ color: "#cd897e" }}>{item.title}</p>
                  <p style={{ color: "#cd897e" }}>{item.subTitle}</p>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    )
  );
}
